"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _classnames = _interopRequireDefault(require("classnames"));

var eventTracker = function eventTracker() {
  _publish.default.trackEvent('userevent', {
    type: 'Topic Initiated',
    click_source: 'Knowledge Base'
  });
};

var cssAnchorName = 'ask-question-widget';
exports.cssAnchorName = cssAnchorName;

var AskQuestionWidget = function AskQuestionWidget() {
  return (0, _preact.h)("div", {
    className: "ask-question-widget__widget"
  }, (0, _preact.h)("div", {
    className: "ask-question-widget__title"
  }, (0, _preact.h)(_phrase.default, {
    p: "ask.question.widget.title"
  })), (0, _preact.h)("div", {
    className: "ask-question-widget__button"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)("topic/new"),
    className: (0, _classnames.default)('btn--cta', 'btn--new-topic', 'qa-topic-new-button', 'pull-right'),
    onClick: function onClick() {
      return eventTracker();
    }
  }, (0, _preact.h)(_phrase.default, {
    p: "ask.question.widget.button"
  }))));
};

var _default = AskQuestionWidget;
exports.default = _default;